module.exports = __webpack_public_path__ + "media/images/talent/mv-slider10-1133b742c764880b2b794ecb1e35fabe.png";